var exports = {
  "Tg": "pullRequestItemContainer__Ej1H2u",
  "o4": "subtitleText__v3KNAQ",
  "ij": "pickerContainer__qusuZR",
  "q7": "Item__KZCiBZ",
};

module.exports = exports;
